import styled from '@emotion/styled'

import { typography } from '../constants'
import Text from './Text'

export default styled(Text)`
  font-weight: ${typography.fontWeight.bold};
`
